import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SharePlan } from '../../types/pool-plans.types';
import { useAppQuery } from '../use-app-query.hook';

export const useApproveHurdleSharePlans = ({
  companyId,
  isTerminated = false,
}: {
  companyId: string;
  isTerminated?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { data: approveHurdleSharePlans = [], isLoading } = useAppQuery<SharePlan[]>({
    queryKey: [QueryKey.GET_APPROVE_SHARE_PLANS, companyId],
    queryFn: () =>
      ApiService.get(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'share-plans', 'hurdle-approve'],
        },
        {
          queryParams: {
            isTerminated,
          },
        },
      ),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_APPROVE_SHARE_PLANS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    approveHurdleSharePlans,
    isLoading,
  };
};
